'use client';

import dynamic from 'next/dynamic';

export const LogoExplosion = dynamic(() => import('./LogoExplosion'));
